/**
 * Progression — XP curve and level helpers. Pure logic, no Phaser/DOM.
 *
 * The level-up itself is applied in combat.js (it needs derived stats), but the
 * curve and progress math live here so the UI and tests can read them freely.
 */

/**
 * XP required to advance FROM the given level to the next.
 * Smooth curve: xpBase * level^xpExp (tunable in balance.json).
 * @param {number} level current level (>= 1)
 * @param {{xpBase:number, xpExp:number}} cfg
 * @returns {number}
 */
export function xpToNext(level, cfg) {
  return Math.max(1, Math.floor(cfg.xpBase * Math.pow(level, cfg.xpExp)));
}

/**
 * Progress toward the next level for a hero.
 * @param {object} hero party member ({ level, xp })
 * @param {{xpBase:number, xpExp:number}} cfg
 * @returns {{have:number, need:number, pct:number}}
 */
export function xpProgress(hero, cfg) {
  const need = xpToNext(hero.level, cfg);
  return { have: hero.xp, need, pct: Math.min(1, hero.xp / need) };
}
